// src/useToast.ts
import { useState, useCallback } from "react";

interface ToastData {
  message: string;
  type: "success" | "error";
  duration: number;
}

const useToast = () => {
  const [toast, setToast] = useState<ToastData | null>(null);

  const showToast = useCallback(
    (message: string, type: "success" | "error", duration = 3000) => {
      setToast({ message, type, duration });
    },
    [],
  );

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  return {
    toast,
    showToast,
    hideToast,
  };
};

export default useToast;
